import { render, staticRenderFns } from "./RoleEditDialog.vue?vue&type=template&id=5cdfe038"
import script from "./RoleEditDialog.vue?vue&type=script&lang=js"
export * from "./RoleEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports